import api from './api';

// The organisation, its team, and invitations to join one.
const organisationService = {
  get: async (id) => (await api.get(`/organisations/${id}`)).data,
  update: async (id, data) => (await api.put(`/organisations/${id}`, data)).data,

  members: async (id) => (await api.get(`/organisations/${id}/members`)).data,
  // Always answers the same way, whether or not the address has an account.
  invite: async (id, email, role) => (await api.post(`/organisations/${id}/members`, { email, role })).data,
  changeRole: async (id, userId, role) => (await api.put(`/organisations/${id}/members/${userId}`, { role })).data,
  removeMember: async (id, userId) => (await api.delete(`/organisations/${id}/members/${userId}`)).data,

  // The invited person decides.
  myInvitations: async () => (await api.get('/me/organisation-invitations')).data,
  accept: async (id) => (await api.post(`/organisation-invitations/${id}/accept`)).data,
  decline: async (id) => (await api.post(`/organisation-invitations/${id}/decline`)).data
};

export default organisationService;
